import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss'],
    standalone: false
})
export class RedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.href = "https://autotaxatiepartners.nl/";
  }

}
